import React from "react";
import "./ResponsivePanel.css";

/**
 * Presentation-only wrapper for workbench side panels.
 *
 * The children stay mounted while the panel is closed so feature state remains
 * owned by the existing component. At desktop widths this behaves like a
 * regular flex child; narrower layouts position it over the workspace.
 */
export default function ResponsivePanel({
  open,
  onClose,
  side = "left",
  label,
  children,
  className = "",
}) {
  const panelClassName = [
    "responsive-panel",
    `responsive-panel--${side}`,
    open ? "is-open" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <>
      <button
        type="button"
        className={`responsive-panel__backdrop ${open ? "is-open" : ""}`}
        aria-label={`Dismiss ${label}`}
        onClick={onClose}
        tabIndex={open ? 0 : -1}
      />
      <aside className={panelClassName} aria-label={label}>
        <button
          type="button"
          className="responsive-panel__close"
          aria-label={`Close ${label}`}
          onClick={onClose}
        >
          <span aria-hidden="true">&times;</span>
        </button>
        {children}
      </aside>
    </>
  );
}
